export enum TipoEsBonificacionRecargo {
    Bonificacion = 0,
    Recargo = 1,
}
